import { createSelector } from 'reselect';
import { getHasOpenActivitySet } from 'lib/selectors/getHasOpenActivitySet';
import { getHasOpenActivity } from 'lib/selectors/getHasOpenActivity';
import { getAreActivitiesEnabled } from 'lib/selectors/getAreActivitiesEnabled';
import { getIsAPMEnabled } from 'lib/selectors/getIsAPMEnabled';
import { getCurrentLaborTicket } from 'lib/selectors/getLaborTickets';
import { getPostLaborUpdatesOnNats } from 'lib/selectors/getPostLaborUpdatesOnNats';

const getIsPaused = createSelector(
  [
    getAreActivitiesEnabled,
    getHasOpenActivitySet,
    getHasOpenActivity,
    getIsAPMEnabled,
    getCurrentLaborTicket,
    getPostLaborUpdatesOnNats,
  ],
  (
    areActivitiesEnabled,
    hasOpenActivitySet,
    hasOpenActivity,
    isAPMEnabled,
    currentLaborTicket,
    natsFlowEnabled
  ) => {
    if (!areActivitiesEnabled || isAPMEnabled) {
      return false;
    }

    // NATS flow: paused is ONLY for setup tickets with keep-open
    if (natsFlowEnabled) {
      const endBehavior = currentLaborTicket?.customFields?.endBehavior;
      const isSetup = currentLaborTicket?.type?.toLowerCase() === 'setup';
      return endBehavior === 'keep-open' && isSetup;
    }

    // Standard flow: check activity state
    return !!(hasOpenActivitySet && !hasOpenActivity);
  }
);

export { getIsPaused };
